module.exports = __webpack_public_path__ + "img/4-4.733811b8.png";